import React from "react";
import { ArrowRight, Star } from "lucide-react";
import { TESTIMONIALS } from "../content";
import { Reveal } from "../hooks";

function ScoreBadge({ before, after }) {
  return (
    <div className="inline-flex items-center gap-2 text-sm font-semibold font-mono whitespace-nowrap">
      <span className="text-muted-foreground line-through">{before}</span>
      <ArrowRight className="h-3.5 w-3.5 text-primary flex-shrink-0" />
      <span className="text-primary">{after}</span>
    </div>
  );
}

function TestimonialCard({ quote, author, uni, before, after, avatar, index }) {
  return (
    <Reveal delay={index * 0.1}>
      <div
        className="bg-card border border-border rounded-2xl p-6 flex flex-col gap-4 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 group h-full"
        data-testid={`testimonial-${avatar}`}
      >
        <div className="flex gap-0.5">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" />
          ))}
        </div>
        <p className="text-sm text-foreground leading-relaxed flex-1 font-plex">
          "{quote}"
        </p>
        <div className="flex flex-col gap-3 pt-3 border-t border-border">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-[#0A0A0A] text-white font-bold text-sm flex items-center justify-center font-mono group-hover:bg-primary transition-colors flex-shrink-0">
              {avatar}
            </div>
            <div className="min-w-0">
              <div className="font-semibold text-sm font-cabinet">{author}</div>
              <div className="text-xs text-muted-foreground font-plex">
                {uni}
              </div>
            </div>
          </div>
          <ScoreBadge before={before} after={after} />
        </div>
      </div>
    </Reveal>
  );
}

export function TestimonialsSection({ testimonials = TESTIMONIALS }) {
  return (
    <section
      className="py-24 px-4 relative overflow-hidden"
      data-testid="testimonials-section"
      style={{
        background:
          "linear-gradient(180deg, hsl(0 0% 100%) 0%, hsl(40 30% 98%) 50%, hsl(0 0% 100%) 100%)",
      }}
    >
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-1.5 mb-3">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="h-4 w-4 fill-amber-400 text-amber-400"
                />
              ))}
              <span className="text-sm font-medium text-muted-foreground ml-1 font-plex">
                4.9/5 from 2,300+ reviews
              </span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-cabinet font-black tracking-tight mb-4">
              Students who let their data guide them.
            </h2>
            <p className="text-lg text-muted-foreground font-plex">
              Real results from students who studied smarter, not just harder.
            </p>
          </div>
        </Reveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t, i) => (
            <TestimonialCard key={i} index={i} {...t} />
          ))}
        </div>
      </div>
    </section>
  );
}
